export const POLICY_DOC_TYPES = {
  html: 'html',
  pdf: 'pdf',
  jpeg: 'jpeg',
};

export const POLICY_DOC_SOURCES = {
  uploaded: 'uploaded',
  algo: 'algo',
  app: 'app',
  illustration: 'illustration',
};

export const POLICY_DOC_ANNUITY_DOCTYPE = {
  annuityApplication: 'AnnuityApplication',
  annuitySuitabilityForm: 'AnnuitySuitabilityForm',
  annuityQualifiedPlanRollover: 'AnnuityQualifiedPlanRollover',
  annuityReplacementForm: 'AnnuityReplacementForm',
  annuityCertificateOfTrustForm: 'AnnuityCertificateOfTrustForm',
  annuitySupplementalReplacementForm: 'AnnuitySupplementalReplacementForm',
  annuityProductDisclosure: 'AnnuityProductDisclosure',
  annuityIDVerificationConsent: 'AnnuityIDVerificationConsentForm',
  annuityProductSnapshot: 'AnnuityProductSnapshot',
  annuityPrivacyPolicy: 'AnnuityPrivacyPolicy',
  annuityRECEConsent: 'AnnuityRECEConsent',
  annuityREEConsent: 'AnnuityREEConsent',
  annuitySVEConsent: 'AnnuitySVEConsent',
  annuityIllustration: 'AnnuityIllustration',
  annuityBuyerGuide: 'AnnuityBuyerGuide',
  annuityStateSupplemental: 'AnnuityStateSupplemental',
  annuityADARForm: 'AnnuityADARForm',
  annuityQLACForm: 'AnnuityQLACForm',
  annuityMM2Disclosure: 'AnnuityMM2Disclosure',
  annuityBeneficiaryIRA: 'AnnuityBeneficiaryIRA',
  annuityProducerTransactionAuthorization: 'AnnuityProducerTransactionAuthorization',
  annuityWithdrawalBenefitRider: 'AnnuityWithdrawalBenefitRider',
  annuityLargeCaseQuestionnaire: 'AnnuityLargeCaseQuestionnaire',
  annuityDisclosureAcknowledgment: 'AnnuityDisclosureAcknowledgment',
};

export const POLICY_DOC_DOCTYPE = {
  aps: 'APS',
  amendment: 'Amendment',
  rx: 'Rx',
  lab: 'Lab results',
  eir: 'EIR',
  taxForm: 'Tax Form',
  financialForm: 'Financial Form',
  visa: 'Visa/Green card',
  i797: 'I-797',
  archive: 'Archive',
  other: 'Other',
  RevisedBasicIllustration: 'RevisedBasicIllustration',
  basicIllustration: 'BasicIllustration',
  mec: 'Mec',
  conversion: 'Conversion',
  papp: 'Papp',
  consent: 'Consent',
  ...POLICY_DOC_ANNUITY_DOCTYPE,
};

export const POLICY_DOC_NAMES = {
  MATReport: 'MAT Report',
  LabsHIPPA: 'Labs HIPPA',
  Amendment: 'ICC16AADTC_Amendment_.pdf',
  Replace: 'Replace',
};

export enum POLICY_DOC_SCAN_STATUS {
  PENDING = 'Pending',
  CLEAN = 'Clean',
  INFECTED = 'Infected',
  NOT_APPLICABLE = 'N/A',
}
